import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { aiModelsApi } from '@/api/endpoints'
import { queryKeys } from '@/config/queryConfig'
import type { GlobalThresholdPatch } from '@/types'

export function useGlobalThresholds() {
  const qc = useQueryClient()
  const key = queryKeys.globalThresholds()
  const query = useQuery({ queryKey: key, queryFn: () => aiModelsApi.getGlobalThresholds() })

  const update = useMutation({
    mutationFn: (patch: GlobalThresholdPatch) => aiModelsApi.updateGlobalThreshold(patch),
    onSuccess: (resp) => qc.setQueryData(key, resp),
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  })

  const reset = useMutation({
    mutationFn: () => aiModelsApi.resetCameraThresholds(),
    onSettled: () => qc.invalidateQueries({ queryKey: key }),
  })

  return {
    models: query.data?.models ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
    saving: update.isPending,
    saveError: update.isError,
    update: update.mutate,
    resetCameras: reset.mutate,
    resetting: reset.isPending,
  }
}
